import React, { useEffect, useState } from "react";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { Callout, Spinner, HTMLSelect } from "@blueprintjs/core";
import { MultiLineChart } from "../../Charts/LineChart";

export default function ParkingOccupancy(props) {
  const [loading, setLoading] = useState(true);
  const [authorized, authorize] = useState(true);
  const [dataset, setDataset] = useState([]);
  const [usertypes, setUserTypes] = useState([]);
  const [usertype, setUserType] = useState("");
  const [by, setBy] = useState("by user type");

  useEffect(() => {
    const ac = new AbortController();
    if (localStorage.getItem("perm_activity") === "true") {
      setLoading(true);
      if (props.urlsearchparams !== undefined) {
        switch (by) {
          case "by park":
            authenticatedGetFetch(
              "/activity/occupancy/park?" + props.urlsearchparams,
              (response) => {
                setLoading(false);
                setDataset(response);
              },
              null,
              ac.signal
            );
            break;

          case "by user type":
            authenticatedGetFetch(
              "/activity/occupancy/usertype?" + props.urlsearchparams,
              (response) => {
                setLoading(false);
                setDataset(response);
                setUserTypes([...response.map((ut) => ut.title)]);
              },
              null,
              ac.signal
            );
            break;

          case "by day of the week":
            let filterut = "";
            if (usertype !== "") filterut = "&usertype=" + usertype;
            authenticatedGetFetch(
              "/activity/occupancy/day?" + props.urlsearchparams + filterut,
              (response) => {
                setLoading(false);
                setDataset(response);
              },
              null,
              ac.signal
            );
            break;

          default:
            break;
        }
      } else {
        setLoading(false);
      }
    } else {
      authorize(false);
    }
  }, [by, usertype, props.urlsearchparams]);

  if (props.urlsearchparams === undefined) return <></>;

  if (!authorized)
    return (
      <Callout intent="warning">
        <Trans>you are not allowed to visualize element:</Trans>
        <Trans>parking occupancy</Trans>
        <br />
        <Trans>
          for any change of your permissions please contact an administrator
        </Trans>
      </Callout>
    );
  else if (props.urlsearchparams) {
    return (
      <Callout
        icon="timeline-line-chart"
        title={<Trans>parking occupancy</Trans>}
      >
        {loading && <Spinner />}
        <HTMLSelect
          value={by}
          options={[
            { label: i18n.t("by user type"), value: "by user type" },
            { label: i18n.t("by park"), value: "by park" },
            {
              label: i18n.t("by day of the week"),
              value: "by day of the week",
            },
          ]}
          onChange={(s) => {
            setLoading(true);
            setBy(s.target.value);
          }}
        />
        {by === "by day of the week" && (
          <HTMLSelect
            value={usertype}
            options={[
              { label: i18n.t("all user types"), value: "" },
              ...usertypes.map((ut) => {
                return { value: ut.split("userType")[1], label: i18n.t(ut) };
              }),
            ]}
            onChange={(s) => {
              setUserType(s.target.value);
            }}
          />
        )}

        {dataset && dataset[0] ? (
          <>
            <div className="flexbox-center">
              {by === "by user type" && (
                <MultiLineChart
                  stacked={true}
                  format="date"
                  datasets={dataset}
                  labels={dataset[0]["labels"]}
                  title={i18n.t("parking occupancy per user type")}
                  large={true}
                />
              )}
              {by === "by park" && (
                <MultiLineChart
                  stacked={true}
                  format="date"
                  datasets={dataset}
                  labels={dataset[0]["labels"]}
                  title={i18n.t("parking occupancy per park")}
                  large={true}
                />
              )}
              {by === "by day of the week" && (
                <MultiLineChart
                  stacked={false}
                  datasets={dataset}
                  labels={dataset[0]["labels"]}
                  title={i18n.t("parking occupancy per day of the week")}
                  large={true}
                />
              )}
              <Callout intent="primary">
                <Trans>explain occupation</Trans>
              </Callout>
            </div>
          </>
        ) : (
          <Callout intent="primary">
            <Trans>no data for the period</Trans>
          </Callout>
        )}
      </Callout>
    );
  }
}
